// Uma pergunta é de grade quando as suas alternativas carregam titulo_grade —
// cada alternativa é o cruzamento de uma linha da grade com uma opção de resposta.
export const isGradeQuestion = (alternativas) =>
  Boolean(alternativas?.some((alternativa) => alternativa.titulo_grade));
